import React, {memo} from "react";
import {Checkbox, FormControl, FormControlLabel, FormHelperText} from "@material-ui/core";
import "./index.scss";


const InputCheckbox = ({name, className, label, value, error, disabled, onChange}) => (
    <FormControl
        className={`checkbox${className ? ' ' + className : ''}`}
        size="small"
        error={!!error}
        disabled={disabled}
    >
        <FormControlLabel
            control={
                <Checkbox
                    id={name}
                    name={name}
                    color="primary"
                    checked={value}
                    onChange={onChange}
                />
            }
            label={label || ''}
        />
        {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
);

export default memo(InputCheckbox);